// The Settings switches, kept on this device (like the theme): Running low
// suggestions, the trip summary, Vibration, the cooking-timer alert and the
// Get started card (and its Garmin step). Ported from the approved
// prototype (feature pack reference/src/settings.ts); its "When someone adds an
// item" switch is left out — there are no notifications in the product.

export interface Prefs {
  /** Show the Running low chips on the list. */
  restock: boolean
  /** Show the trip summary after Finish trip (TripSummarySheet). */
  tripSummary: boolean
  /** Every haptic in the app (lib/haptics.ts). */
  haptics: boolean
  /** Sound and vibration when a cooking timer ends. */
  notifyTimer: boolean
  /** The Get started card on the list (components/list/GetStarted). Hide turns it off. */
  getStarted: boolean
  /** The card's Garmin step; "I don't have a Garmin" turns it off. */
  watchStep: boolean
}

export const DEFAULT_PREFS: Prefs = { restock: true, tripSummary: true, haptics: true, notifyTimer: true, getStarted: true, watchStep: true }
export const PREFS_STORAGE_KEY = 'matlist.prefs'

export const togglePref = (p: Prefs, k: keyof Prefs): Prefs => ({ ...p, [k]: !p[k] })

/** Whatever is stored, read safely: bad JSON or a wrong-typed field falls back to the default. */
export function readPrefs(raw: string | null): Prefs {
  let v: unknown
  try { v = JSON.parse(raw ?? '') } catch { return { ...DEFAULT_PREFS } }
  const out = { ...DEFAULT_PREFS }
  if (v && typeof v === 'object') {
    for (const k of Object.keys(DEFAULT_PREFS) as (keyof Prefs)[]) {
      const x = (v as Record<string, unknown>)[k]
      if (typeof x === 'boolean') out[k] = x
    }
  }
  return out
}
